<template>
  <div>
    <div class="dynamic-asset-list-page">
      <h2 class="th-title">
        <b> {{ formattedSubCategoryTitle }}</b>
      </h2>

      <a-card>
        <div class="row justify-content-between  mb-3">
          <div class="col-lg-10">
            <div class="row">
              <div class="col-md-6 mb-2">
                <a-input-search
                  placeholder="Cari Aset..."
                  class="w-100"
                  v-model:value="searchQuery"
                  @input="handleSearch"
                />
              </div>
              <div class="col-md-6 mb-2">
                <a-select
                  v-model:value="selectedFilterCustomer"
                  show-search
                  placeholder="Pilih customer"
                  class="w-100"
                  :options="customerOptions"
                  :filter-option="filterOption"
                  allow-clear
                >
                </a-select>
              </div>
              <div class="col-md-6 mb-2">
                <a-select
                  v-model:value="selectedFilterLokasi"
                  show-search
                  placeholder="Pilih lokasi"
                  class="w-100"
                  :options="lokasiOptions"
                  :filter-option="filterOption"
                  allow-clear
                >
                </a-select>
              </div>
              <div class="col-md-6 mb-2">
                <a-button @click="clearFilter" class="w-100">Clear Filters</a-button>
              </div>
            </div>
          </div>

          <div class="col-lg-2">
            <div class="d-flex flex-column justify-content-end">
              <router-link
                :to="{
                  name: 'CreateDynamicAsset',
                  query: {
                    subCategory: subCategoryParam,
                  },
                }"
                v-if="role !== 'dcOwner'"
                class="mb-2"
              >
                <a-button type="primary" class="w-100">
                  <PlusOutlined /> Tambah Aset Baru
                </a-button>
              </router-link>

              <a-button type="default" @click="exportToExcel" v-if="!exportLoading">
                <DownloadOutlined /> Export Excel
              </a-button>
              <a-button type="default" loading v-else>Exporting</a-button>
            </div>
          </div>
        </div>

        <a-table
          :columns="role === 'dcOwner' ? columnsDcOwner : columns"
          :data-source="paginatedData"
          class="table"
          :loading="loading"
          :pagination="pagination"
          @change="handleTableChange"
          row-key="id"
          bordered
          table-layout="auto"
        >
          <template #name="{ text, record }">
            <router-link
              class="th-link"
              :to="{
                name: 'Detail Asset Dinamis',
                params: {
                  subCategory: subCategoryParam,
                  id: record.id,
                },
                // id: record.id,
                // subCategory: subCategoryParam,
              }"
            >
              {{ text }}
            </router-link>
          </template>

          <template #AssetSubCategory="{ text }">
            <div>
              {{ text ? text.name : '-' }}
              <br />
              <span class="text-muted">
                {{ text && text.AssetCategory ? text.AssetCategory.name : '-' }}
              </span>
            </div>
          </template>

          <template #Manufacturer="{ text }">
            {{ text ? text.name : '-' }}
            <br />
            <span class="text-muted"># {{ text ? text.tag : '-' }}</span>
          </template>
          <template #Vendor="{ record }">
            {{ record.Vendor ? record.Vendor.name : '-' }}
          </template>

          <template #Customer="{ text }">
            {{ text ? text.name : '-' }}
            <br />
            <span class="text-muted">
              {{ text ? text.officeNumber : '-' }}
              <br />
              {{ text ? text.email : '-' }}
            </span>
          </template>

          <template #Location="{ text, record }">
            {{ text ? text.name : '-' }}
            <br />
            <span class="text-muted">
              {{ record.Room ? record.Room.name : '-' }}
            </span>
          </template>
          <template #Value="{  record }">
            <span class="text-muted">
              {{
                record.MaintenanceInformations.length
                  ? record.MaintenanceInformations[record.MaintenanceInformations.length - 1].value
                    ? rupiah(
                        record.MaintenanceInformations[record.MaintenanceInformations.length - 1]
                          .value,
                      )
                    : rupiah(record.ProcurementInformation.value)
                  : rupiah(record.ProcurementInformation.value)
              }}
            </span>
          </template>

          <template #status="{ text }">
            <span>
              <a-tag :color="text == 'Pending' ? 'orange' : 'green'"> {{ text }}</a-tag>
            </span>
          </template>

          <template #aksi="{ record }">
            <a-popconfirm
              title="Apakah anda yakin akan mengaktifkan asset ini?"
              ok-text="Ya"
              cancel-text="Tidak"
              @confirm="approveAsset(record.id)"
              v-if="record.status == 'Pending'"
            >
              <a-button>Aktifkan</a-button>
            </a-popconfirm>
            <a-tag v-else color="green">Aktif</a-tag>
          </template>

          <template #action="{ record }">
            <!-- <a-button type="primary" size="small" @click="editAsset(record)">Edit</a-button> -->
            <a-button type="ghost" size="small" @click="deleteAsset(record)">Delete</a-button>
          </template>
        </a-table>
      </a-card>
    </div>
    <a-modal
      v-model:visible="deleteModalVisible"
      title="Hapus Asset"
      @ok="handleDeleteAsset"
      centered
    >
      <p>Yakin ingin menghapus asset?</p>
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch, computed } from 'vue'
import { PlusOutlined, DownloadOutlined } from '@ant-design/icons-vue'
import { notification, Space, Tag, Button, Popconfirm } from 'ant-design-vue'
import {
  getAssets,
  editStatusAssetsById,
  getAssetSubCategory,
  deleteAssetsById,
} from '../../services/axios/modc/assets'

import { getLocations, getRooms, getCustomers } from '../../services/axios/modc/customer'
import { useRoute } from 'vue-router'

import * as XLSX from 'xlsx'

export default defineComponent({
  components: {
    PlusOutlined,
    DownloadOutlined,
    // Space,
    // Tag,
    // Button,
    // Popconfirm,
  },
  setup() {
    const route = useRoute()
    const allAssets = ref([])
    const loading = ref(false)
    const searchQuery = ref('')

    const pagination = ref({ current: 1, pageSize: 10, total: 0 })
    const deleteModalVisible = ref(false)
    const subCategoryParam = computed(() => route.params.subCategory)

    const columns = [
      {
        title: 'NAMA ASSET',
        dataIndex: 'name',
        className: '',
        key: 'name',
        slots: { customRender: 'name' },
        width: 150,
      },
      {
        title: 'TIPE ASSET',
        dataIndex: 'AssetSubCategory',
        className: '',
        key: 'AssetSubCategory',
        slots: { customRender: 'AssetSubCategory' },
        width: 150,
      },
      {
        title: 'BRAND',
        dataIndex: 'Manufacturer',
        className: '',
        key: 'Manufacturer',
        slots: { customRender: 'Manufacturer' },
      },
      // {
      //   title: 'VENDOR',
      //   dataIndex: 'Vendor',
      //   className: '',
      //   key: 'Vendor',
      //   slots: { customRender: 'Vendor' },
      // },
      { title: 'SERIAL NO', dataIndex: 'serialNumber', className: '', key: 'serialNumber' },
      {
        title: 'CUSTOMER',
        dataIndex: 'Customer',
        className: '',
        key: 'Customer',
        slots: { customRender: 'Customer' },
      },

      {
        title: 'LOCATION',
        dataIndex: 'Location',
        className: '',
        key: 'Location',
        slots: { customRender: 'Location' },
        onFilter: (value, record) => record.Location?.id === value,
      },
      {
        title: 'VALUE',
        dataIndex: 'Value',
        className: '',
        key: 'Value',
        slots: { customRender: 'Value' },
      },
      {
        title: 'STATUS',
        dataIndex: 'status',
        className: '',
        key: 'status',
        slots: { customRender: 'status' },
        filters: [
          { text: 'Active', value: 'Active' },
          { text: 'Pending', value: 'Pending' },
        ],
        onFilter: (value, record) => record.status == value,
      },
      // {
      //   title: 'AKSI',
      //   dataIndex: 'aksi',
      //   className: '',
      //   key: 'aksi',
      //   slots: { customRender: 'aksi' },
      // },
      { title: 'Aksi', key: 'action', slots: { customRender: 'action' }, width: 120 },
    ]
    const columnsDcOwner = [
      {
        title: 'NAMA ASSET',
        dataIndex: 'name',
        className: '',
        key: 'name',
        slots: { customRender: 'name' },
        width: 150,
      },
      {
        title: 'TIPE ASSET',
        dataIndex: 'AssetSubCategory',
        className: '',
        key: 'AssetSubCategory',
        slots: { customRender: 'AssetSubCategory' },
        width: 150,
      },
      {
        title: 'BRAND',
        dataIndex: 'Manufacturer',
        className: '',
        key: 'Manufacturer',
        slots: { customRender: 'Manufacturer' },
      },
      { title: 'SERIAL NO', dataIndex: 'serialNumber', className: '', key: 'serialNumber' },
      {
        title: 'CUSTOMER',
        dataIndex: 'Customer',
        className: '',
        key: 'Customer',
        slots: { customRender: 'Customer' },
      },
      {
        title: 'LOCATION',
        dataIndex: 'Location',
        className: '',
        key: 'Location',
        slots: { customRender: 'Location' },
      },
      {
        title: 'STATUS',
        dataIndex: 'status',
        className: '',
        key: 'status',
        slots: { customRender: 'status' },
        filters: [
          { text: 'Active', value: 'Active' },
          { text: 'Pending', value: 'Pending' },
        ],
        onFilter: (value, record) => record.status == value,
      },
    ]

    const columnsInfra = [
      {
        title: 'NAMA ASSET',
        dataIndex: 'name',
        className: '',
        key: 'name',
        slots: { customRender: 'name' },
        width: 150,
      },
      {
        title: 'TIPE ASSET',
        dataIndex: 'AssetSubCategory',
        className: '',
        key: 'AssetSubCategory',
        slots: { customRender: 'AssetSubCategory' },
        width: 150,
      },
      {
        title: 'CUSTOMER',
        dataIndex: 'Customer',
        className: '',
        key: 'Customer',
        slots: { customRender: 'Customer' },
      },
      {
        title: 'LOCATION',
        dataIndex: 'Location',
        className: '',
        key: 'Location',
        slots: { customRender: 'Location' },
      },
      {
        title: 'STATUS',
        dataIndex: 'status',
        className: '',
        key: 'status',
        slots: { customRender: 'status' },
        filters: [
          { text: 'Active', value: 'Active' },
          { text: 'Pending', value: 'Pending' },
        ],
        onFilter: (value, record) => record.status == value,
      },
      {
        title: 'AKSI',
        dataIndex: 'aksi',
        className: '',
        key: 'aksi',
        slots: { customRender: 'aksi' },
      },
      { title: 'Aksi (Edit/Delete)', key: 'action', slots: { customRender: 'action' }, width: 120 },
    ]
    const dataAssetSubCategories = ref([])
    const formattedSubCategoryTitle = computed(() => {
      const subCategoryId = Number(subCategoryParam.value)
      const filtered = dataAssetSubCategories.value.filter(el => el.id === subCategoryId)

      return filtered[0]?.name
    })
    const role = ref('')
    const fetchData = async () => {
      const storedUserData = localStorage.getItem('userData')
      const userData = JSON.parse(storedUserData)
      role.value = userData.user.role
      const { categories } = await getAssetSubCategory()
      dataAssetSubCategories.value = categories
      loading.value = true
      let typeFilter = null
      const subCategoryIdNum = Number(subCategoryParam.value)

      if (isNaN(subCategoryIdNum) && subCategoryParam.value === 'infrastruktur') {
        typeFilter = encodeURIComponent(JSON.stringify([1, 2, 4, 9, 12, 5, 6]))
      } else if (!isNaN(subCategoryIdNum)) {
        typeFilter = subCategoryIdNum
      } else {
        console.warn(`[Dynamic Assets] SubCategory tidak valid: ${subCategoryParam.value}.`)
        allAssets.value = []
        pagination.value.total = 0
        loading.value = false
        notification.error({ message: 'Error', description: 'Parameter subkategori tidak valid.' })
        return
      }

      try {
        const response = await getAssets(
          { type: typeFilter },
          '',
          '',
          '', // Urutan, Lokasi, Ruangan
          '', // Kosongkan parameter search di sini
          '',
          role.value,
        )

        allAssets.value = response.assets.map(asset => ({
          ...asset,
          AssetCategoryName:
            asset.AssetSubCategory && asset.AssetSubCategory.AssetCategory
              ? asset.AssetSubCategory.AssetCategory.name
              : 'N/A',
          AssetSubCategoryName: asset.AssetSubCategory ? asset.AssetSubCategory.name : 'N/A',
        }))
        notification.success({ message: 'Sukses', description: 'Daftar aset dimuat.' })
      } catch (error) {
        console.error('Gagal memuat aset:', error)
        notification.error({ message: 'Error', description: 'Gagal memuat daftar aset.' })
        allAssets.value = []
      } finally {
        loading.value = false
      }
    }

    const filteredAssets = computed(() => {
      let filtered = [...allAssets.value]
      if (selectedFilterLokasi.value) {
        filtered = filtered.filter(asset => asset.Location?.id === selectedFilterLokasi.value)
      }
      if (selectedFilterCustomer.value) {
        filtered = filtered.filter(asset => asset.Customer?.id === selectedFilterCustomer.value)
      }

      if (searchQuery.value && searchQuery.value.trim() !== '') {
        const lowerCaseSearch = searchQuery.value.toLowerCase()
        filtered = filtered.filter(asset => {
          const nameMatch = asset.name && asset.name.toLowerCase().includes(lowerCaseSearch)
          const subCategoryNameMatch =
            asset.AssetSubCategoryName &&
            asset.AssetSubCategoryName.toLowerCase().includes(lowerCaseSearch)
          const manufacturerMatch =
            asset.Manufacturer &&
            asset.Manufacturer.name &&
            asset.Manufacturer.name.toLowerCase().includes(lowerCaseSearch)
          const customerMatch =
            asset.Customer &&
            asset.Customer.name &&
            asset.Customer.name.toLowerCase().includes(lowerCaseSearch)
          const locationMatch =
            asset.Location &&
            asset.Location.name &&
            asset.Location.name.toLowerCase().includes(lowerCaseSearch)
          const roomMatch =
            asset.Room && asset.Room.name && asset.Room.name.toLowerCase().includes(lowerCaseSearch)
          const serialNumberMatch =
            asset.serialNumber && asset.serialNumber.toLowerCase().includes(lowerCaseSearch)

          return (
            nameMatch ||
            subCategoryNameMatch ||
            manufacturerMatch ||
            customerMatch ||
            locationMatch ||
            roomMatch ||
            serialNumberMatch
          )
        })
      }
      return filtered
    })

    const paginatedData = computed(() => {
      const startIndex = (pagination.value.current - 1) * pagination.value.pageSize
      const endIndex = startIndex + pagination.value.pageSize
      return filteredAssets.value.slice(startIndex, endIndex)
    })

    const handleSearch = () => {
      pagination.value.current = 1
      pagination.value = {
        ...pagination.value,
        total: filteredAssets.value.length,
      }
    }
    const rupiah = number => {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(number)
    }

    const handleSearchLokasi = e => {
      console.log(e)
    }

    const handleTableChange = pag => {
      pagination.value.current = pag.current
      pagination.value.pageSize = pag.pageSize
    }

    const editAsset = record => {
      console.log('Edit Aset:', record)
      notification.info({ message: 'Info', description: `Edit aset ${record.name}` })
    }
    const clearFilter = () => {
      selectedFilterCustomer.value = ''
      selectedFilterLokasi.value = ''
    }
    const selectedData = ref({})
    const deleteAsset = record => {
      console.log('Delete Aset:', record)
      selectedData.value = record
      deleteModalVisible.value = true
    }

    const handleDeleteAsset = async () => {
      await deleteAssetsById(selectedData.value.id)
      notification.success({
        message: 'Berhasil Dihapus',
        description: 'Data Asset Berhasil Dihapus',
      })
      await fetchData()
      deleteModalVisible.value = false
    }

    const approveAsset = async id => {
      const res = await editStatusAssetsById(id)
      if (res) {
        notification.success({
          message: 'Berhasil Diaktifkan',
          description: 'Data Asset Berhasil Diaktifkan',
        })
      } else {
        notification.error({
          message: 'Server Error',
          description: 'Internal Server Error',
        })
      }
      await fetchData()
    }

    // --- Fungsi Export Excel ---
    const exportLoading = ref(false)
    const exportToExcel = () => {
      exportLoading.value = true
      let currentColumns = subCategoryParam.value !== 'infrastruktur' ? columns : columnsInfra

      // Filter kolom untuk menghapus kolom 'aksi' dan 'action' (Edit/Delete)
      const columnsForExport = currentColumns.filter(
        col => col.key !== 'aksi' && col.key !== 'action',
      )

      // Siapkan header Excel
      const header = columnsForExport.map(col => col.title)

      // Siapkan data Excel
      const dataForExport = filteredAssets.value.map(record => {
        const row = {}
        columnsForExport.forEach(col => {
          // Tangani data bersarang atau slot custom render yang sederhana
          if (col.dataIndex === 'AssetSubCategory') {
            row[col.title] = record.AssetSubCategory ? record.AssetSubCategory.name : '-'
          } else if (col.dataIndex === 'Manufacturer') {
            row[col.title] = record.Manufacturer ? record.Manufacturer.name : '-'
          } else if (col.dataIndex === 'Customer') {
            row[col.title] = record.Customer ? record.Customer.name : '-'
          } else if (col.dataIndex === 'Location') {
            row[col.title] = record.Location ? record.Location.name : '-'
          } else if (col.dataIndex === 'AssetCategoryName') {
            row[col.title] = record.AssetCategoryName
          } else if (col.dataIndex === 'AssetSubCategoryName') {
            // Jika ada kolom ini
            row[col.title] = record.AssetSubCategoryName
          } else if (col.dataIndex === 'Value') {
            // Jika ada kolom ini
            row[col.title] = record.MaintenanceInformations.length
              ? record.MaintenanceInformations[record.MaintenanceInformations.length - 1].value
                ? rupiah(
                    record.MaintenanceInformations[record.MaintenanceInformations.length - 1].value,
                  )
                : rupiah(record.ProcurementInformation.value)
              : rupiah(record.ProcurementInformation.value)
          } else {
            // Untuk dataIndex tunggal atau serialNumber/name/status
            row[col.title] = record[col.dataIndex] !== undefined ? record[col.dataIndex] : '-'
          }
        })
        return row
      })

      // --- Tambahkan Lebar Kolom ke Worksheet ---
      const ws = XLSX.utils.json_to_sheet(dataForExport, { header: header })

      // Tentukan lebar kolom. Ini adalah contoh, Anda bisa menyesuaikan angkanya.
      // Sesuaikan dengan jumlah kolom yang diekspor dan urutannya.
      const wscols = columnsForExport.map(col => ({
        // col.width mungkin dalam px, kita perlu konversi ke karakter.
        // Konversi kasar: 1 karakter ~ 6-8px.
        // Atau set lebar default yang masuk akal.
        wch: Math.max(col.title.length, 20), // Minimum 20 karakter, atau sepanjang judul kolom
      }))

      // Contoh lebar kolom spesifik berdasarkan dataIndex/judul
      columnsForExport.forEach((col, index) => {
        switch (col.dataIndex) {
          case 'name':
            wscols[index] = { wch: 30 } // Nama Aset lebih lebar
            break
          case 'Customer':
            wscols[index] = { wch: 40 } // Customer lebih lebar
            break
          case 'Location':
            wscols[index] = { wch: 30 } // Lokasi lebih lebar
            break
          case 'serialNumber':
            wscols[index] = { wch: 25 } // Serial No.
            break
          case 'AssetSubCategory':
            wscols[index] = { wch: 25 } // Tipe Aset
            break
          // ... tambahkan case lain untuk kolom spesifik
          default:
            // Jika Anda tidak ingin menyesuaikan, bisa menggunakan logika default di atas
            // wscols[index] = { wch: 20 }; // Default untuk yang lain
            break
        }
        // Pastikan lebar kolom tidak lebih kecil dari panjang judul
        if (wscols[index].wch < col.title.length) {
          wscols[index].wch = col.title.length
        }
      })

      ws['!cols'] = wscols // Tetapkan lebar kolom ke worksheet

      // Buat workbook dan tambahkan worksheet
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Daftar Aset')

      // Tentukan nama file
      const fileName = `${formattedSubCategoryTitle.value}_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`

      // Tulis file
      XLSX.writeFile(wb, fileName)
      exportLoading.value = false
      notification.success({
        message: 'Export Berhasil',
        description: `Data aset telah diekspor ke ${fileName}`,
      })
    }
    let filterCustomer = ref([])
    let filterLokasi = ref([])
    const selectedFilterLokasi = ref()
    const selectedFilterCustomer = ref()
    const fetchLocation = async () => {
      const { locations } = await getLocations()
      const { customer } = await getCustomers()
      // console.log(customer, 'inicustomerrr')
      filterLokasi.value = locations.map(e => ({ name: e.name, id: e.id }))
      filterCustomer.value = customer.map(e => ({ name: e.name, id: e.id }))
    }
    const lokasiOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Lokasi' }

      return [
        defaultOption,
        ...filterLokasi.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const customerOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Customer' }

      return [
        defaultOption,
        ...filterCustomer.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const filterOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    onMounted(() => {
      fetchLocation()
    })

    watch(
      subCategoryParam,
      () => {
        pagination.value.current = 1
        fetchData()
      },
      { immediate: true },
    )

    watch(
      filteredAssets,
      newFilteredList => {
        // 1. Perbarui total pagination dengan panjang array yang baru
        pagination.value.total = newFilteredList.length

        // 2. (PENTING) Kembalikan pengguna ke halaman pertama setiap kali filter berubah
        // Ini untuk mencegah bug di mana pengguna tetap di halaman 5 padahal hasil filter hanya 1 halaman.
        if (pagination.value.current !== 1) {
          pagination.value.current = 1
        }
      },
      {
        // Jalankan saat komponen pertama kali dimuat
        immediate: true,
      },
    )
    return {
      customerOptions,
      lokasiOptions,
      filterOption,
      loading,
      searchQuery,
      pagination,
      columns,
      columnsInfra,
      formattedSubCategoryTitle,
      handleSearch,
      handleTableChange,
      editAsset,
      deleteAsset,
      approveAsset,
      subCategoryParam,
      paginatedData,
      exportToExcel,
      exportLoading,
      role,
      columnsDcOwner,
      deleteModalVisible,
      handleDeleteAsset,
      filterLokasi,
      selectedFilterLokasi,
      selectedFilterCustomer,
      handleSearchLokasi,
      filterCustomer,
      clearFilter,
      rupiah,
    }
  },
})
</script>

<style scoped>
/* Tambahkan gaya khusus untuk halaman ini jika diperlukan */
.dynamic-asset-list-page {
  /* padding: 20px; */
}
/* .th-title {
  font-size: 1.5rem;
  margin-bottom: 20px;
} */
.th-link {
  color: var(--vb-color-primary) !important;
  &:hover {
    color: var(--kit-color-primary) !important;
  }
}
</style>
